import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Card from '../card/card';
import MenuSearchableList from '../searchable-list/menu-searchable-list';
import Paginator from '../paginator/paginator';
import { getLoginById } from './../../services/loginService'
import OutsideClick from '../outside-click/outside-click';
import { toast } from "react-toastify";
import { setSiteAction, updateSitesAction } from "../../store/site/actions";
import { IAppState } from '../../store/types';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { SearchTerm } from '../../models/search/SearchTerm';
import { DEF_PG_SIZE_FILTER } from '../../constants/maximum-page-size';
import { getErrorMessage, showError } from '../../services/utilities/ServiceError';
import { useDialog } from '../dialog/DialogContext';
import { HomeIcon } from './home-icon';

interface Props {
    onSelect?: any
    fetchData: any
    isCompact?: boolean
}

const initialSearchTerm: SearchTerm = {
    accessor: "",
    translationKey: ""
}

const SiteMenuList: FC<Props> = ({ onSelect = () => { }, fetchData, isCompact = false }) => {
    const mountedRef = useRef(true);
    const updateSite = useSelector((state: IAppState) => (state.site.updateSites));
    const userLoginId = useSelector((state: IAppState) => (state.userInfo.id));
    const dispatch = useDispatch()
    const [rows, setRows] = useState<any[]>([]);
    const [paginationObject, setPaginationObject] = useState({ totalCount: 33, maxPageSize: DEF_PG_SIZE_FILTER, totalPages: 2, pageNumber: 1 });
    const [openMenu, setOpenMenu] = useState(false)
    const [currentUser, setCurrentUser] = useState<any>()
    const { translate } = useLocale();
    const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
    const label = useSelector((state: IAppState) => state.site.site.label)
    const dialog = useDialog();

    useEffect(() => {
        mountedRef.current = true;
        return () => { mountedRef.current = false; };
    }, [])

    useEffect(() => {
        getUserLoginData();
    }, [])

    useEffect(() => {
        getData();
        dispatch(updateSitesAction(false));
    }, [fetchData.name, paginationObject.pageNumber, updateSite, searchTerm])

    const dispatchPageNumberAction = (newPageNumber: number) => {
        setPaginationObject({ ...paginationObject, pageNumber: newPageNumber })
    };

    const getData = async () => {
        try {
            const siteObject = await fetchData({ goToPage: paginationObject.pageNumber, pageSize: DEF_PG_SIZE_FILTER, searchTerm: searchTerm });
            if (!mountedRef.current) {
                return;
            }
            setPaginationObject(siteObject.pagination)
            const rows = siteObject?.rows?.map(el => ({ label: el.name, value: el.id }))
            setRows(rows)
        } catch (error) {
            if (!mountedRef.current) {
                return;
            }
            showError(error, toast.warn);
        }
    }

    const getUserLoginData = async () => {
        try {
            const currentUser = await getLoginById(userLoginId) as any
            if (!mountedRef.current) {
                return;
            }
            setCurrentUser(currentUser)
            dispatch(setSiteAction({ label: currentUser.site, value: currentUser.siteId }))
            dispatch(updateSitesAction(false))
        } catch (error) {
            if (!mountedRef.current) {
                return;
            }
            showError(error, toast.warn);
        }
    }

    const saveLogin = (values, site) => {
        const newLogin = {
            ...values,
            siteId: site.value,
            site: site.label
        };

        return newLogin
    }

    const selectItem = async (item) => {
        setOpenMenu(false)
        try {
            onSelect(item?.value);
            dispatch(setSiteAction(item))
        } catch (error) {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) })
        }
    };

    function SiteInitialsBadge(item: any) {
        return (
            <div className="flex flex-row items-center cursor-pointer" onClick={() => selectItem(item)} >
                <div className="">{item.label}</div>
            </div>)
    }
    const findSelectedItems = () => {
        return []
    };

    const handleSearchUpdate = (newSearchTerm: string) => {
        setSearchTerm({ value: newSearchTerm, accessor: "siteName", translationKey: "" });
    }


    return (<div className="relative">
        {isCompact
            ? (
                <button id='siteDropDownBtn' onClick={() => setOpenMenu(!openMenu)} type="button" title={label} className="w-full flex justify-center items-center py-3 bg-sidemenu-focus">
                    <HomeIcon className="h-5" />
                </button>
            ) : (
                <button id='siteDropDownBtn' onClick={() => setOpenMenu(!openMenu)} type="button" className="bg-sidemenu-focus w-full py-3 px-5 text-white">
                    <div className="flex flex-row items-center">
                        <HomeIcon className="h-5" />
                        <div className="pl-3 text-base font-medium truncate">
                            {label}
                        </div>
                        <FontAwesomeIcon className="ml-auto text-md flex-shrink-0" icon={openMenu ? faChevronUp : faChevronDown} />
                    </div>
                </button>
            )
        }
        {
            openMenu && <OutsideClick onClick={() => setOpenMenu(false)}>
                <Card hasBorder={false} className="bg-white shadow-2xl p-4 content-selection-list overflow-y-auto" style={{ position: 'absolute', zIndex: 51, left: 0, top: '100%' }}>  <Paginator itemCount={paginationObject.totalCount} compact sizes={[10]} paginationObj={paginationObject} onPageNumberUpdated={dispatchPageNumberAction} onPageSizeUpdated={() => { }}>
                    {({ start, end }) => (
                        <>
                            <div>
                                <div className="">{translate.byKey(TranslationKeys.selectSiteToSaveTo)}</div>
                                <div className="text-xs text-gray-600 mt-1 mb-4">{translate.byKey(TranslationKeys.selectSiteToSaveToDesc)}</div>
                                <MenuSearchableList
                                    items={rows.map((item, index) => (
                                        SiteInitialsBadge(item)
                                    ))}
                                    onSelect={() => console.log('open')} title="Names" selectedItems={findSelectedItems()} onSearch={handleSearchUpdate}
                                    searchBoxClassName="mb-4" titleClassName="mb-0" stripedListClassName="mb-2" stripedListItemClassName="p-1 pl-3"
                                    selectedListItemClassName="p-1 pl-1-5 border-l-7 border-portal-blue-primary bg-selection-highlight border-t-selection-highlight border-r-selection-highlight border-b-selection-highlight"/>
                            </div>
                        </>)}
                </Paginator></Card></OutsideClick >
        }
    </div>
    )
};

export default SiteMenuList;
